import { useQuery } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const POLL_INTERVAL_MS = 5e3;
const isRunActive = (workflow) => Boolean(workflow == null ? void 0 : workflow.active_run_id);
const fetchWorkflowDefinition = (id) => AIAgentDefinitions.get(id);
const useWorkflowDefinition = (id) => useQuery({
  queryKey: [...WORKFLOW_DEFINITIONS_QUERY_KEY, "detail", id],
  queryFn: () => fetchWorkflowDefinition(id),
  enabled: Boolean(id),
  refetchInterval: ({ state }) => isRunActive(state.data) ? POLL_INTERVAL_MS : false,
  // App default disables focus refetch; re-enable it so a second tab notices a run started elsewhere.
  refetchOnWindowFocus: true,
  // Cheap query — always revalidate (focus, mount, reconnect) rather than keep a cache window.
  staleTime: 0
});
export default useWorkflowDefinition;
